import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToLocation } from '../scrollLocation';

export function ScrollManager() {
  const { hash, key, pathname } = useLocation();

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';

    return () => {
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    return scrollToLocation(hash);
  }, [hash, key, pathname]);

  return null;
}
